// Toolbar presets for QuillEditor's `toolbar-options`. Plain constants: they never
// change, so components import them instead of mixing in computed copies.
type QuillToolbar = Array<Array<string | Record<string, unknown>>>;

// Bold / italic / underline, lists and code blocks: notes, messages, forms.
export const QUILL_TOOLBAR_BASE: QuillToolbar = [
  ['bold', 'italic', 'underline'],
  [{ list: 'ordered' }, { list: 'bullet' }],
  ['code-block'],
];

// The full Quill toolbar: profile and company descriptions, report sections.
export const QUILL_TOOLBAR_EXTENDED: QuillToolbar = [
  ['bold', 'italic', 'underline', 'strike'], // toggled buttons
  ['blockquote', 'code-block', 'link'],

  [{ header: 1 }, { header: 2 }], // custom button values
  [{ list: 'ordered' }, { list: 'bullet' }],
  [{ script: 'sub' }, { script: 'super' }], // superscript/subscript
  [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
  [{ direction: 'rtl' }], // text direction

  [{ size: ['small', false, 'large', 'huge'] }], // custom dropdown
  [{ header: [1, 2, 3, 4, 5, 6, false] }],

  [{ color: [] }, { background: [] }], // dropdown with defaults from theme
  [{ font: [] }],
  [{ align: [] }],

  ['clean'], // remove formatting button
];
